<template lang="pug">
  .assign-table
    v-container(style="max-width:600px")
      div.d-flex.align-center.mt-3
        v-icon(left color="black" :size="24" @click="$router.push('/admin/restaurant/pos-setup')") mdi-arrow-left
        div.h6.primary--text {{ $t('table_available') }}
      div.px-3
        div.mt-4.p1.primary--text {{ $t('description') }}
        div.mt-6(v-if="settings" style="border:1px solid var(--v-basic500); border-radius: 10px;")
          div.pa-4
            div(@click="openAssignTableDialog = true")
              div.d-flex.align-center
                template(v-if="tableEnabled")
                  div.s1.basic700--text {{ $t('number_of_table') }}: {{ tableNumber }}
                  v-spacer
                  eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic600")
                template(v-else)
                  div.s1.basic700--text {{ $t('setup_number_of_tables') }}
                  v-spacer
                  eva-icon.mb-n2(name="chevron-right-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic600")

    .modals
      y-dialog(fill-height v-model="openAssignTableDialog" scrollable persistent max-width="600px")
        v-card
          v-card-title.pa-4
            p.mb-0.h6.basic800--text {{ $t('assign_table') }}
          v-divider.basic300

          v-card-text.pa-4
            div.p1.primary--text {{ $t('how_many_table') }}
            div.d-flex.mt-4
              v-spacer
              v-btn.my-auto(icon @click="tableNumber--" :disabled="tableNumber < 1")
                eva-icon.mt-1(name="minus-circle-outline" height="28" width="28" :fill="tableNumber < 1 ? $vuetify.theme.themes[$theme].textColorDisabled : $vuetify.theme.themes[$theme].primary500")
              v-layout.divbox.s1.my-auto.text-center.mx-3
                .s1.ma-auto {{ tableNumber }}
              v-btn.my-auto(icon @click="tableNumber++")
                eva-icon.mt-1(name="plus-circle-outline" height="28" width="28" :fill="$vuetify.theme.themes[$theme].primary500")
              v-spacer

          v-card-actions
            v-spacer
            v-btn(color='white', text @click="openAssignTableDialog = false")
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' depressed height=32 @click="clickSave" :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
export default {
  name: 'AssignTable',
  props: ['company'],
  data () {
    return {
      isLoading: false,
      tableNumber: 0,
      tableEnabled: false,
      openAssignTableDialog: false,
      settings: null
    }
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    fetchSettings () {
      this.$axios.get(`/pos/${this.company.slug}/settings`)
        .then(resp => {
          this.settings = resp.data
          this.tableNumber = resp.data.table_count
          this.tableEnabled = resp.data.table_assignment_enabled
        })
    },
    clickSave () {
      this.isLoading = true
      if (this.tableNumber > 0) {
        this.tableEnabled = true
      } else {
        this.tableEnabled  = false
      }
      this.settings.table_assignment_enabled = this.tableEnabled,
      this.settings.table_count = this.tableNumber
      this.$axios.post(`/pos/${this.company.slug}/settings`, this.settings)
        .then(resp => {
          this.settings = resp.data
          this.tableNumber = resp.data.table_count
          this.tableEnabled = resp.data.table_assignment_enabled
          this.openAssignTableDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.divbox {
  border: 2px solid var(--v-basic400);
  background-color: var(--v-basic200);
  height: 40px;
  max-width: 60px;
  border-radius: 5px;
}
</style>

<i18n>
{
  "en": {
    "description": "Assign number to each table available in your restaurant. This table number will be use for your Table Ordering.",
    "how_many_table": "How many table in your restaurant?"
  },
  "id": {
    "description": "Tetapkan nomor untuk setiap meja yang tersedia di restoran Anda. Nomor meja ini akan digunakan untuk Pemesanan Meja Anda.",
    "how_many_table": "Berapa banyak meja di restoran Anda?"
  }
}
</i18n>
